import DossierBasicInfo from 'components/dossiers/DossierBasicInfo'
import DossierFinancialInfo from 'components/dossiers/DossierFinancialInfo'
import DossierFollowUpContainer from "components/dossiers/dossierFollowUp/DossierFollowUpContainer";
import RoutedTab from 'components/generics/RoutedTab'
import React from 'react'
import { connect } from 'react-redux'

import { withRouter } from 'react-router-dom'
import { findEntity } from 'selectors/entities'
import { DropdownItem } from "semantic-ui-react";
import { DropdownMenu } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { upsertEntity } from "../../actions/entities.js";
import { updateEntity } from "../../actions/entities.js";
import { fetchEntities } from "../../actions/entities.js";
import { getCurrentEmployment } from "../../selectors/employments";
import MergeDossiersForm from "./MergeDossiersForm";
import DossierExportModal from "./DossierExportModal";

class Dossier extends React.Component {
  componentDidMount () {
    this.props.fetchDossier();
  }
  render() {
    const { dossier, fullAccess } = this.props
    const archived = dossier?.isArchived

    if (!dossier) {
      return <div>{I18n.t('components.dossier.not_loaded')}</div>
    }

    const followUpPane = { label: I18n.t('components.dossier.follow_up') , key:"follow-up-tab", render: () => <DossierFollowUpContainer dossierId={dossier.id}/>, path: Routes.dossier_path({id: dossier.id, _options: true })}
    const infoPane = { label: I18n.t('components.dossier.basic_info'), key:"basic-info-tab", render: () => <DossierBasicInfo dossier={dossier}/> , path: Routes.dossier_info_path({id: dossier.id, _options: true })}
    const docsPane =   { label: I18n.t('components.dossier.financial'), key:"financial-tab" , render: () => <DossierFinancialInfo dossier={dossier}/>, path: Routes.dossier_financial_path({id: dossier.id, _options: true }) }

    const panes = fullAccess ? [followUpPane, infoPane, docsPane] : [infoPane]

    const extraMenuItems =  fullAccess ? [<Dropdown key={'dossier_actions_dropdown'} item icon='ellipsis horizontal' active='' >
                              <DropdownMenu>
                                <DropdownItem icon='archive' onClick={() =>this.props.archiveDossier(!archived)}
                                              text= {archived? I18n.t('components.dossier.restore') : I18n.t('components.dossier.archive')} />
                                <MergeDossiersForm currentDossierId={dossier.id} trigger={<DropdownItem icon='fork' text={I18n.t('components.dossier.merge.title')}  />}/>
                                <DossierExportModal dossierId={dossier.id} trigger={<DropdownItem icon='download' text={I18n.t('components.dossier.export.export_pdf')}/>}/>
                              </DropdownMenu>
                            </Dropdown>] : null

    return (
      <RoutedTab panes={panes} archived={dossier.isArchived} extraMenuItems={extraMenuItems}/>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const current = getCurrentEmployment(state)
  return {
    dossier: findEntity(state, 'dossier', ownProps.dossierId),
    fullAccess: state.view !== 'admin' || (current && current.roles.includes('full_access'))
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDossier: () => {
      dispatch(fetchEntities('dossiers', {name: 'dossier', filter: {id: ownProps.dossierId}, page: 1}))
    },
    archiveDossier: (archive) => {
      dispatch(updateEntity('dossier', {id: ownProps.dossierId, isArchived: archive}))
      dispatch(upsertEntity('dossier', ownProps.dossierId))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dossier));
